import { t } from '@lingui/core/macro'
import { Card } from '@tecsinapse/cortex-react'
import React, { useCallback, useState } from 'react'
import { createPortal } from 'react-dom'
import {
  Produto,
  UsuarioEdicaoSecondPageQueryQuery,
  UsuarioEdicaoSecondPageQueryQueryVariables
} from '@/core/types/graphql'
import { moveElementToFirst } from '@/core/utils/objects'
import { USUARIO_EDICAO_SECOND_PAGE_QUERY } from '../../data/second-page-query'
import CardProdutoPermissao from './card-produto-permissao'
import UsuarioClonarPermissaoModal from './usuario-clonar-permissao-modal'
import FiltroProdutoPermissao from './filtro-produto-permissao'
import { useQuery } from '@apollo/client'

import { useWatch } from 'react-hook-form'
import { OptionSelect } from '@/core/utils/types'
import { useUsuarioEdicaoSecondPageOnboarding } from '../../hooks/use-onboarding-second-page'

export const UsuarioEdicaoSecondPage = () => {
  const { setNextStepAndOpen } = useUsuarioEdicaoSecondPageOnboarding()
  const values = useWatch()

  const [modalClonarProdutos, setModalClonarProdutos] = useState<Produto[]>(
    [] as Produto[]
  )
  const [isClonarOpen, setIsClonarOpen] = useState<boolean>(false)

  const handleOpenClonar = useCallback(() => setIsClonarOpen(true), [])
  const handleCloseClonar = useCallback(() => setIsClonarOpen(false), [])
  const [filtroSelecionado, setFiltroSelecionado] = useState<string[]>([])

  const tipoUsuario = values.tipo.value
  const { loading, data: produtosData } = useQuery<
    UsuarioEdicaoSecondPageQueryQuery,
    UsuarioEdicaoSecondPageQueryQueryVariables
  >(USUARIO_EDICAO_SECOND_PAGE_QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      idsDealer: values.idsDealers.map((dealer: OptionSelect) => dealer.value),
      tipoUsuario
    }
  })
  const produtos = produtosData?.produtosByDealersAndTipoUsuario ?? []

  if (loading) {
    return null
  }

  const listaProdutosFiltrada =
    filtroSelecionado.length === 0
      ? produtos
      : produtos?.filter(p => filtroSelecionado.includes(String(p?.id)))

  const temPortal = listaProdutosFiltrada?.some(p => p?.nome === 'Portal')

  const listaProdutosOrdenada = temPortal
    ? moveElementToFirst(listaProdutosFiltrada, 'nome', 'Portal')
    : listaProdutosFiltrada

  return (
    <div>
      <>
        <Card>
          <p className={'font-bold mb-deca'}>
            {t`Selecione o perfil de acesso do usuário para cada módulo abaixo:`}
          </p>

          <FiltroProdutoPermissao
            produtos={produtos}
            filtroSelecionado={filtroSelecionado}
            setFiltroSelecionado={setFiltroSelecionado}
          />

          <div className={'space-y-deca mt-deca'}>
            {(listaProdutosOrdenada ?? []).map(
              (produto: Produto, index: number) => (
                <CardProdutoPermissao
                  key={`${produto?.id}-${index}`}
                  tourId={index === 0 ? 'first-product-permissions' : undefined}
                  produto={produto}
                  setProdutos={setModalClonarProdutos}
                  onOpen={handleOpenClonar}
                  onOpenTour={index === 0 ? setNextStepAndOpen : undefined}
                />
              )
            )}
          </div>

          {createPortal(
            <UsuarioClonarPermissaoModal
              customProps={{
                open: isClonarOpen,
                produtos: modalClonarProdutos
              }}
              onClose={handleCloseClonar}
              onOpenTable={handleOpenClonar}
            />,
            document.body
          )}
        </Card>
      </>
    </div>
  )
}
